// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__iDM-6","paginationButton":"Pagination_paginationButton__jU57k","activePage":"Pagination_activePage__i-mMz"};